const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutputs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "30 45 95 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-406.8-1191.1h-133.9c-6.6,0-12-5.4-12-12V-1337c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-394.8-1196.5-400.2-1191.1-406.8-1191.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-406.8-962.4h-133.9c-6.6,0-12-5.4-12-12v-133.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-394.8-967.8-400.2-962.4-406.8-962.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-406.8-733.8h-133.9c-6.6,0-12-5.4-12-12v-133.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-394.8-739.2-400.2-733.8-406.8-733.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-406.8-505.2h-133.9c-6.6,0-12-5.4-12-12V-651c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-394.8-510.6-400.2-505.2-406.8-505.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-406.8-276.5h-133.9c-6.6,0-12-5.4-12-12v-133.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-394.8-281.9-400.2-276.5-406.8-276.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-406.8-47.9h-133.9c-6.6,0-12-5.4-12-12v-133.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-394.8-53.3-400.2-47.9-406.8-47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-406.8,180.8h-133.9c-6.6,0-12-5.4-12-12V34.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-394.8,175.4-400.2,180.8-406.8,180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-406.8,409.4h-133.9c-6.6,0-12-5.4-12-12V263.5c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-394.8,404-400.2,409.4-406.8,409.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeMiterlimit: 10
    },
    d: "M70.6,91.8H39.1c-1.1,0-2-0.9-2-2V58.3 c0-1.1,0.9-2,2-2h31.5c1.1,0,2,0.9,2,2v31.5C72.6,90.9,71.7,91.8,70.6,91.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeMiterlimit: 10
    },
    d: "M116.8,91.8H85.3c-1.1,0-2-0.9-2-2V58.3 c0-1.1,0.9-2,2-2h31.5c1.1,0,2,0.9,2,2v31.5C118.8,90.9,117.9,91.8,116.8,91.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeMiterlimit: 10
    },
    d: "M70.6,137.9H39.1c-1.1,0-2-0.9-2-2v-31.5 c0-1.1,0.9-2,2-2h31.5c1.1,0,2,0.9,2,2v31.5C72.6,137,71.7,137.9,70.6,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeMiterlimit: 10
    },
    d: "M116.8,137.9H85.3c-1.1,0-2-0.9-2-2v-31.5 c0-1.1,0.9-2,2-2h31.5c1.1,0,2,0.9,2,2v31.5C118.8,137,117.9,137.9,116.8,137.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutputs);
export default __webpack_public_path__ + "static/media/Outputs.fa5788e486211118d39bed211158ef48.svg";
export { ForwardRef as ReactComponent };